import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import type { TextFieldProps } from '@mui/material';
import type { Control } from 'react-hook-form';

type Props = Omit<TextFieldProps, 'type' | 'onChange' | 'inputProps'> & {
  name: string;
  control?: Control<any>;
  step?: number;
  minValue?: number;
  maxValue?: number;
};

export default function ControlledNumericField({
  name,
  control: propControl,
  step = 0.01,
  minValue,
  maxValue,
  variant = 'outlined',
  ...textFieldProps
}: Props) {
  'use memo';

  const formContext = useFormContext();
  const control = propControl ?? formContext?.control;

  if (!control) {
    throw new Error(
      'ControlledNumericField requires either a control prop or a FormProvider ancestor.'
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          value={field.value}
          onChange={({ target: { value } }) => {
            field.onChange(value === '' ? null : Number(value));
          }}
          type="number"
          slotProps={{
            htmlInput: {
              step: step,
              min: minValue,
              max: maxValue
            }
          }}
          variant={variant}
          error={!!fieldState?.error?.type}
          helperText={fieldState?.error?.message}
          fullWidth
          size="small"
          {...textFieldProps}
        />
      )}
    />
  );
}
